import { render, staticRenderFns } from "./ChatSofia.vue?vue&type=template&id=4d349418"
import script from "./ChatSofia.vue?vue&type=script&lang=js"
export * from "./ChatSofia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports